import { each, map } from 'lodash-es';

const enums = {
  email: 'sähköposti',
  phone: 'puhelimitse',
};

const titles = {
  livingArea: 'Pinta-ala',
  location: 'Sijainti',
  propertyType: 'Kohdetyyppi',
  numberOfRooms: 'Huoneluku',
  contactTime: 'Yhteydenottoaika',
  contactTypes: 'Yhteydenottotapa',
};

const formatMessage = (form: any) => {
  const message = form.message ? `${form.message}\n\n` : '';
  return formatExtraFields(message, form, titles);
};

const formatExtraFields = (message: string, fields: any, titles: any) => {
  each(fields, (value, key) => {
    value = `${value}`; // convert to string
    if (value && value.length > 0 && titles[key]) {
      // @ts-ignore - Until types fixed
      const val = Array.isArray(value) ? map(value, (v) => enums[v] || v) : enums[value] || value;
      message += `${titles[key]}: ${val}\n`;
    }
  });
  return message;
};

export default {
  formatMessage,
  formatExtraFields,
};
